import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronLeft } from 'lucide-react';
import CreateDCQForm from './CreateDCQForm';
import useCreateDCQForm from './useCreateDCQForm';

function CreateDCQ() {
  const { participantID } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const formProps = useCreateDCQForm({ participantID, navigate, location });

  return (
    <div className="max-w-3xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: -8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="mb-1"
      >
        <button
          onClick={() => navigate(-1)}
          className="back-link"
        >
          <ChevronLeft className="h-4 w-4" />
          <span>Back</span>
        </button>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="card overflow-hidden"
      >
        <div className="card-band">
          <div>
            <h2 className="card-band-title">Create New DCQ</h2>
            <p className="card-band-description">Fill out the form below to create a new Data Clarification Query</p>
          </div>
        </div>
        <div className="p-6">
          <CreateDCQForm {...formProps} />
        </div>
      </motion.div>
    </div>
  );
}

export default CreateDCQ;